import MentorSettingsPageMainComponent, {
  EMR_SETTINGS_SECTIONS,
} from 'src/mentor/components/MentorSettingsPage/MentorSettingsPageMainComponent'
import MentorHeader from '../MentorHeader'
import { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'

export default function MentorSettingsPage() {
  const { mentorClinicAssociationData, mentorProfileData } = useContext(MentorProfileContext)
  // The settings page renders practitioner-only widgets (PrescriptionViewSettings,
  // PortalViewSettings, AppointmentCalendarSettings, …) that hit
  // /api/secure/practitioner/emr-settings/** endpoints — all gated server-side
  // by ROLE_TEACHER/ROLE_MENTOR. A non-practitioner mounting this page
  // produced a 403 storm in prod (web.stdout.log 06:03–06:15: 184 unhandled
  // AccessDeniedExceptions on settings/final-report-view from a single user).
  // Redirect away before any of those widgets get a chance to fire.
  const roles = getAllRolesInBoolean() || {}
  const isPractitioner = !!(roles.isTeacher || roles.isDoctor || roles.isTherapist || roles.isScreener)
  if (!isPractitioner) {
    return <Navigate to="/mentor-home/profile" replace />
  }
  return (
    <div style={{ height: '100%', flexDirection: 'column', display: 'flex' }}>
      <MentorHeader greetingsEnabled={true} />
      <MentorSettingsPageMainComponent
        mentorClinicAssociationData={mentorClinicAssociationData}
        defaultSelectedSection={EMR_SETTINGS_SECTIONS.updateLocalData.id}
        excludeSections={[EMR_SETTINGS_SECTIONS.supportOnlyDoctorSettings.id]}
        mentorProfileData={mentorProfileData}
      />
    </div>
  )
}
